export default {
    lmsUserList: [],
}
